import React from 'react';
import ReactDOM from 'react-dom/client';

import './shared/styles/index.css';
import './shared/styles/FormElements.css'
import App from './app/App';
import {BrowserRouter as Router} from "react-router-dom";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <Router>
        <App />
      </Router>
  </React.StrictMode>
);
